import { render, staticRenderFns } from "./GeneralError.vue?vue&type=template&id=10dbdb30"
import script from "./GeneralError.vue?vue&type=script&lang=ts"
export * from "./GeneralError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports